export default "assets/images/fond-texture-c5614180.png";